export default "__VITE_ASSET__9fe35769__"